import React from 'react';
import { useTranslation } from 'react-i18next';
import { ButtonWithIcon } from '@ff-os/shared-react/components/buttons/button-with-icon/ButtonWithIcon';
import { Button } from '@ff-os/shared-react/components/buttons/button/Button';
import { WindowFooter } from '@ff-os/shared-react/components/window/partials/WindowFooter';
import { GiftOrderButton } from '../../../order-button/GiftOrderButton';
import styles from './GiftWindowFooter.module.scss';

export const GiftWindowFooter = ({
    onClose, next, previous,
    quantity,
    nextButtonText, previousButtonText
}: Props) => {
    const { t } = useTranslation();
    return (
        <WindowFooter>
            {previous ? (
                <ButtonWithIcon className={styles.button}
                    icon='general-ui-chevron-left' position='left' style='outline'
                    onClick={previous}>
                    {previousButtonText}
                </ButtonWithIcon>
            ) : (
                <Button className={styles.button} style='outline' onClick={onClose}>
                    {t('commons.close')}
                </Button>
            )}

            {next ? (
                <ButtonWithIcon className={styles.button}
                    icon='general-ui-chevron-right'
                    position='right'
                    onClick={next}>
                    {nextButtonText}
                </ButtonWithIcon>
            ) : (
                <GiftOrderButton className={styles.button} quantity={quantity} />
            )}
        </WindowFooter>
    );
};

type Props = {
    quantity?: number;
    onClose: () => void;
    previous: (() => void) | undefined;
    previousButtonText: string | undefined;
    next: (() => void) | undefined;
    nextButtonText: string | undefined;
};